export default __webpack_public_path__ + "static/media/boy1.21233799.svg";